import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api, { CUSTOMER_TOKEN_KEY, TOKEN_KEY } from "../lib/api";

const CustomerContext = createContext(null);
export const useCustomer = () => useContext(CustomerContext);

export function CustomerProvider({ children }) {
  const [user, setUser] = useState(null);

  const check = useCallback(async () => {
    const t = localStorage.getItem(CUSTOMER_TOKEN_KEY);
    // Do not treat an admin-only session as a customer
    if (!t || localStorage.getItem(TOKEN_KEY)) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data && (data.role === "customer" || data.role === "admin") ? data : false);
    } catch {
      localStorage.removeItem(CUSTOMER_TOKEN_KEY);
      setUser(false);
    }
  }, []);

  useEffect(() => { check(); }, [check]);

  const googleCustomer = async (session_id) => {
    const { data } = await api.post("/auth/google-customer", { session_id });
    localStorage.setItem(CUSTOMER_TOKEN_KEY, data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(CUSTOMER_TOKEN_KEY);
    setUser(false);
  };

  const startLogin = () => {
    const redirectUrl = window.location.origin + "/auth/customer";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <CustomerContext.Provider value={{ user, googleCustomer, logout, startLogin, check }}>
      {children}
    </CustomerContext.Provider>
  );
}
